<div class="auth-page-container">
  <div class="modal_auth text-center">
    <a [routerLink]="['/']" class="auth-brand" title="Voltar ao início" aria-label="FundCube - Página inicial">
      <img src="images/fundCubeLogo.png" alt="FundCube" class="auth-brand-img" />
    </a>

    <div class="activate-account-content">
      <div *ngIf="isLoading" class="activate-spinner-wrap">
        <p-progress-spinner strokeWidth="5" fill="transparent" animationDuration=".75s"
          [style]="{ width: '70px', height: '70px' }" />
        <h2 class="auth-title mt-4">A ativar a sua conta...</h2>
        <p class="auth-subtitle">Aguarde um instante enquanto validamos as suas credenciais.</p>
      </div>

      <div *ngIf="isSuccess" class="activate-status-wrap success">
        <div class="status-icon-circle success">
          <i class="fas fa-check-circle"></i>
        </div>
        <h2 class="auth-title mt-3">Conta ativada com sucesso!</h2>
        <p class="auth-subtitle">A sua conta foi confirmada. Já pode iniciar sessão e explorar projectos.</p>
        <button type="button" (click)="goToLogin()" class="btn btn-primary btn-full mt-4">
          Iniciar Sessão
        </button>
      </div>

      <div *ngIf="isFalha" class="activate-status-wrap falha">
        <div class="status-icon-circle falha">
          <i class="fas fa-times-circle"></i>
        </div>
        <h2 class="auth-title mt-3">Falha ao ativar conta</h2>
        <p class="auth-subtitle">O link de ativação expirou ou é inválido. Tente novamente mais tarde.</p>
        <a [routerLink]="['/']" class="btn btn-outline btn-full mt-4">
          Voltar à Página Inicial
        </a>
      </div>
    </div>
  </div>
</div>